const height = state => state.height
export default {
  height
}



// WEBPACK FOOTER //
// ./src/store/getters.js